// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iWWX","disabled":"styles_disabled__14ejm"};